import { createContext } from 'react';
export const AuthContext = createContext({
    user: null,
    loading: true,
    pending2FAEmail: null,
    login: async () => 'SUCCESS',
    verifyOtp: async () => { },
    resendOtp: async () => { },
    logout: async () => { },
    refreshUser: async () => { },
});
